export const NETWORK_ERRORS_NEW = "NETWORK_ERRORS_NEW";
export const NETWORK_ERRORS_CLEAR = "NETWORK_ERRORS_CLEAR";
